'use client';

import { c as _c } from "react/compiler-runtime";
import { ScrollArea } from '@achra/ui/scroll-area';
import { useLayoutEffect, useRef } from 'react';
interface ServiceSectionsCardListProps {
  items: string[];
}
function ServiceSectionsCardList(t0) {
  const $ = _c(10);
  const {
    items
  } = t0;
  const rootRef = useRef(null);
  const topFadeRef = useRef(null);
  const bottomFadeRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const root = rootRef.current;
      if (!root) {
        return;
      }
      const viewport = root.querySelector("[data-slot=\"scroll-area-viewport\"]");
      if (!viewport) {
        return;
      }
      const update = () => {
        const distanceToBottom = viewport.scrollHeight - viewport.scrollTop - viewport.clientHeight;
        if (bottomFadeRef.current) {
          bottomFadeRef.current.style.opacity = distanceToBottom <= 1 ? "0" : "1";
        }
        if (topFadeRef.current) {
          topFadeRef.current.style.opacity = viewport.scrollTop <= 0 ? "0" : "1";
        }
      };
      update();
      viewport.addEventListener("scroll", update, {
        passive: true
      });
      const observer = new ResizeObserver(update);
      observer.observe(viewport);
      const list = viewport.querySelector("ul");
      if (list) {
        observer.observe(list);
      }
      return () => {
        viewport.removeEventListener("scroll", update);
        observer.disconnect();
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[2] !== items) {
    t3 = items.map(_temp);
    $[2] = items;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <ScrollArea className="h-full"><ul className="pr-4">{t3}</ul></ScrollArea>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div ref={topFadeRef} aria-hidden={true} className="from-card pointer-events-none absolute inset-x-0 top-0 h-8 bg-linear-to-b to-transparent opacity-0 transition-opacity duration-150" />;
    t6 = <div ref={bottomFadeRef} aria-hidden={true} className="from-card pointer-events-none absolute inset-x-0 bottom-0 h-8 bg-linear-to-t to-transparent opacity-0 transition-opacity duration-150" />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4) {
    t7 = <div ref={rootRef} className="contents">{t4}{t5}{t6}</div>;
    $[8] = t4;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}
function _temp(item) {
  return <li key={item} className="mb-0 ml-2 flex items-center gap-2"><div className="bg-foreground size-1 min-w-1 rounded-full" /><span>{item}</span></li>;
}
export { ServiceSectionsCardList };